// @ts-nocheck
import PropTypes from 'prop-types';
import { House, CalendarBlank, Info } from '@phosphor-icons/react';
import './MobileNavigation.css';

const MobileNavigation = ({ activeTab, onTabChange }) => {
  const tabs = [
    {
      id: 'overview',
      label: 'Overview',
      icon: House
    },
    {
      id: 'itinerary',
      label: 'Itinerary',
      icon: CalendarBlank
    },
    {
      id: 'info',
      label: 'Info',
      icon: Info
    }
    //TODO: Re-enable Ask Me tab when requirements are clear
    //,{  id: 'askme', label: 'Ask Me', icon: ChatCircle }
  ];

  return (
    <nav className='pwa-mobile-navigation'>
      <div className='pwa-mobile-navigation__container'>
        {tabs.map((tab) => {
          const IconComponent = tab?.icon;
          const isActive = activeTab === tab?.id;

          return (
            <button
              key={tab?.id}
              className={`pwa-mobile-navigation__tab ${
                isActive ? 'pwa-mobile-navigation__tab--active' : ''
              }`}
              onClick={() => onTabChange(tab.id)}
              aria-label={`Go to ${tab?.label}`}
            >
              <span className='pwa-mobile-navigation__icon' aria-hidden='true'>
                <IconComponent
                  size={20}
                  weight={isActive ? 'fill' : 'regular'}
                />
              </span>
              <span className='pwa-mobile-navigation__label'>{tab?.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

MobileNavigation.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired
};

export default MobileNavigation;
